var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex loader-wrapper"},[_c('div',{staticClass:"d-flex align-center loader-background"},[_c(_vm.loaderType,_vm._b({tag:"component"},'component',_vm.loaderProps,false)),_c('label',{staticClass:"ml-05"},[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }